import { render } from "./AdminCampaignTypeSelector.vue?vue&type=template&id=825f4afc&scoped=true"
import script from "./AdminCampaignTypeSelector.vue?vue&type=script&lang=js"
export * from "./AdminCampaignTypeSelector.vue?vue&type=script&lang=js"

import "./AdminCampaignTypeSelector.vue?vue&type=style&index=0&id=825f4afc&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825f4afc"]])

export default __exports__